import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import PrintComponents from "react-print-components";
import PrintTicket from "./PrintTicket";
import React, { useState, useRef } from 'react';
import { BsPrinter, BsTrash3, BsThreeDots, BsPencil } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { showDeleteConfirm } from '../../../ItemDelete';
import MergeView from './MergeView';
import CustomEditor from '../../../Editor';
import axios from 'axios';
import { toast } from 'react-toastify';
import { headers } from '../../../../helpers/Requests';
import { linkify } from '../../../../helpers/linkify';

export function TicketActions({ ticket, onComplete, onMergeComplete, onUpdate, reports }) {
    const history = useHistory();
    const [showEditModal, setShowEditModal] = useState(false);
    const [title, setTitle] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const editorRef = useRef(null);

    const handleDelete = () => {
        showDeleteConfirm(ticket, 'ticket', 'ticket', () => {}, () => history.replace('/tickets'))
    };

    const handleEditTicket = () => {
        setTitle(ticket?.title || '');
        setShowEditModal(true);
    };

    const handleCloseModal = () => {
        setShowEditModal(false);
    };

    const handleSaveChanges = async () => {
        try {
            setIsSubmitting(true);

            // Get content from editor
            const description = editorRef.current.getHTML();

            // Create payload with updated ticket data
            const payload = {
                title,
                description: linkify(description),
            };

            // Make API call to update the ticket using headers from Requests.js
            const response = await axios.patch(
                `/api/ticket-update/${ticket.id}`,
                payload,
                headers
            );

            if (response.data.success) {
                toast.success("Ticket updated successfully");
                setShowEditModal(false);
                if (onUpdate) {
                    onUpdate({ title, description: linkify(description) });
                } else if (onComplete) {
                    onComplete();
                }
            } else {
                toast.error(response.data.message || "Failed to update ticket");
            }
        } catch (error) {
            console.error("Error updating ticket:", error);
            toast.error(error.response?.data?.message || "An error occurred while updating the ticket");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="d-inline-flex align-items-center">
            <Dropdown>
                <Dropdown.Toggle variant="secondary" size="sm" className="dropdown-no-arrow" id="dropdown-basic">
                    <BsThreeDots />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ fontSize: '14px' }}>
                    <MergeView onComplete={onMergeComplete ?? onComplete} ticket={ticket}/>
                    {/* <Dropdown.Item onClick={handleDelete}>
                        <BsTrash3 className="me-1" />Delete
                    </Dropdown.Item> */}
                    <Dropdown.Item>
                        <PrintComponents trigger={<div>
                            <BsPrinter className="me-1" />Print
                        </div>}>
                            <PrintTicket reports={reports} ticket={ticket} />
                        </PrintComponents>
                    </Dropdown.Item>

                    <Dropdown.Item onClick={handleEditTicket}>
                        <div className="d-flex align-items-center">
                            <BsPencil className="me-1" />Edit
                        </div>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            {/* Edit Ticket Modal */}
            <Modal show={showEditModal} onHide={handleCloseModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Ticket #{ticket?.ticket_id}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <CustomEditor
                                ref={editorRef}
                                defaultValue={ticket?.description || ''}
                                placeholder="Edit ticket description"
                            />
                        </Form.Group>
                        {/* Add more form fields as needed for ticket editing */}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSaveChanges}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
